"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllLeadStatus = () => {
  const [leadStatus, setLeadStatus] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [newLeadStatus, setNewLeadStatus] = useState({
    lead_status: "",
  });

  /* ================= FETCH LEAD STATUS ================= */
  useEffect(() => {
    fetchLeadStatus();
  }, []);

  const fetchLeadStatus = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        "https://logicx.premierlam.com/api/get-pixel-lead-status",
        { headers: { authorization: localStorage.getItem("accessToken") } }
      );
      setLeadStatus(res.data.data || []);
    } catch {
      toast.error("Failed to fetch lead status");
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= ADD LEAD STATUS ================= */
  const handleAddLeadStatus = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);

      await axios.post(
        "https://logicx.premierlam.com/api/add-pixel-lead-status",
        newLeadStatus,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
            "Content-Type": "application/json",
          },
        }
      );

      toast.success("Lead status added successfully!");
      setIsAddDialogOpen(false);
      setNewLeadStatus({ lead_status: "" });
      fetchLeadStatus();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to add lead status");
    } finally {
      setIsSubmitting(false);
    }
  };

  const filteredLeadStatus = leadStatus.filter((l) =>
    l.lead_status?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="min-h-screen bg-gray-50 p-2">
        <div className="max-w-7xl mx-auto">

          {/* HEADER */}
          <div className="flex justify-between items-start mb-6">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900 mb-1">
                Lead Status
              </h1>
              <p className="text-gray-500">Manage lead status</p>
            </div>

            <button
              onClick={() => setIsAddDialogOpen(true)}
              className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg"
            >
              + Add Lead Status
            </button>
          </div>

          {/* TABLE */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <input
              type="text"
              placeholder="Search lead status"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="mb-4 px-4 py-2 border rounded-lg w-64"
            />

            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="text-center py-6">Loading...</div>
              ) : (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b text-gray-600">
                      <th className="py-3 px-4 text-left">Lead Status</th>
                      <th className="py-3 px-4 text-left">Created At</th>
                      <th className="py-3 px-4 text-left">Added By</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredLeadStatus.map((l) => (
                      <tr key={l.id} className="border-b hover:bg-gray-50">
                        <td className="py-3 px-4">{l.lead_status}</td>
                        <td className="py-3 px-4 whitespace-nowrap">
                          {formatDate(l.created_at)}
                        </td>
                        <td className="py-3 px-4">{l.added_by}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {/* ADD MODAL */}
          {isAddDialogOpen && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
              <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md relative">
                <button
                  className="absolute top-2 right-2 text-gray-400"
                  onClick={() => setIsAddDialogOpen(false)}
                >
                  ✖
                </button>

                <h2 className="text-lg font-semibold mb-4">Add Lead Status</h2>

                <form onSubmit={handleAddLeadStatus} className="space-y-3">
                  <input
                    type="text"
                    placeholder="Lead Status"
                    value={newLeadStatus.lead_status}
                    onChange={(e) =>
                      setNewLeadStatus({ lead_status: e.target.value })
                    }
                    className="w-full border rounded px-3 py-2"
                    required
                  />

                  <div className="flex justify-end gap-3 pt-3">
                    <button
                      type="button"
                      onClick={() => setIsAddDialogOpen(false)}
                      className="px-4 py-2 bg-gray-100 rounded"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="px-4 py-2 bg-orange-500 text-white rounded"
                    >
                      {isSubmitting ? "Adding..." : "Add"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default AllLeadStatus;
